import { atom } from 'jotai';

export const deviceIdAtom = atom<string|undefined>();
